<template>
  <div v-if="visible" :class="['notification-banner', customClass]" :style="computedStyle">
    <div class="notification-content">
      <img v-if="icon" :src="iconPath" alt="icon" class="notification-icon" />
      <span class="notification-message" v-html="message"></span>
      <div class="notification-buttons">
        <button
          v-for="(button, index) in extraButtons"
          :id="`notification-banner-btn-${index + 1}`"
          :key="button.label"
          @click="openLink(button.url)"
          class="extra-button"
        >
          {{ button.label }}
        </button>
        <button
          @click="closeNotification"
          id="notification-banner-btn-close"
          class="close-button"
        >
          {{ closeButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonBannerNotification',
  props: {
    icon: String,
    customClass: String,
    customStyle: Object,
    extraButtons: {
      type: Array,
      default: () => [],
    },
    closeButtonText: {
      type: String,
      default: 'Fechar',
    },
    pushContent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      message: '',
    };
  },
  computed: {
    iconPath() {
      return this.icon ? require(`@/assets/img/main/icons/icon-${this.icon}-component.svg`) : '';
    },
    computedStyle() {
      if (this.pushContent) {
        return {
          ...this.customStyle,
          display: 'block',
          position: 'sticky',
        };
      }
      return this.customStyle;
    },
  },
  methods: {
    showNotification(msg) {
      this.message = msg;
      this.visible = true;
    },
    closeNotification() {
      this.visible = false;
    },
    openLink(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #CAE3F2;
  padding: 15px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .notification-content {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .notification-icon {
    margin-right: 10px;
  }

  .notification-message {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 500;
    text-align: left;
    color: #0c203d;
    flex-grow: 1;
  }

  .notification-buttons {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .extra-button,
  .close-button {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    color: #536B78;
    background: transparent;
    border: none;
    cursor: pointer;
    margin-left: 10px;
    padding: 5px 10px;
    border-radius: 50px;
    transition: background-color 0.3s ease, color 0.3s ease;

    &:hover {
      color: #5a6d7e;
    }
  }

  .close-button {
    color: #536B78;

    &:hover {
      color: #5a6d7e;
    }
  }
}
</style>
